<tt-page>
    <tt-page-heading>{{ heading }}</tt-page-heading>
    <tt-project-folders [params]="params" (getLoaded)="onGetLoaded($event)"></tt-project-folders>
</tt-page>
